window.handleConsent = function (action) {
    var userConsent = '';
    var shopifyConsent = '';
    var consent = '';
    var ad_storage = '';
    var ad_user_data = '';
    var ad_personalization = '';
    var personalization_storage = '';
    var analytics_storage = '';
    var functionality_storage = '';
    var security_storage = '';
    window.dataLayer = window.dataLayer || [];
    
    function gtag() {
        dataLayer.push(arguments);
    }
    
    function getCookie(name) {
        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? decodeURIComponent(value[1]) : null;
    }

    userConsent = JSON.parse(getCookie('_tracking_consent')).con.CMP;
    consent = {
        "analytics": userConsent.a,
        "marketing": userConsent.m,
        "preferences": userConsent.p,
        "sale_of_data": userConsent.s
    };
    
    if (consent.marketing == 1 && consent.sale_of_data == 1) {
        ad_storage = "granted";
        ad_user_data = "granted";
        ad_personalization = "granted";
        personalization_storage = "granted";
    } else {
        ad_storage = "denied";
        ad_user_data = "denied";
        ad_personalization = "denied";
        personalization_storage = "denied";
    }
    if (consent.analytics == 1) {
        analytics_storage = "granted";
    } else {
        analytics_storage = "denied";
    }
    functionality_storage = "granted";
    security_storage = "granted";
    
    shopifyConsent = {
        "ad_storage": ad_storage,
        "ad_user_data": ad_user_data,
        "ad_personalization": ad_personalization,
        "analytics_storage": analytics_storage,
        "functionality_storage": functionality_storage,
        "personalization_storage": personalization_storage,
        "security_storage": security_storage
    };
    
    gtag('consent', 'default', {
        "ad_storage": "denied",
        "ad_user_data": "denied",
        "ad_personalization": "denied",
        "analytics_storage": "denied",
        "functionality_storage": "granted",
        "personalization_storage": "denied",
        "security_storage": "granted"
    });
    gtag('consent', 'update', shopifyConsent);
}
handleConsent();
